import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/enterpriseApplications/messages";
import { camelizeKeys } from "lib/helpers";

function* getEntApplicationsCsv(action) {
  const params = {
    ...action.payload,
    csv: true,
  };

  const { success, data, error } = yield* makeRequest.get("/enterprise_applications", params);

  if (success && data) {
    yield put(actions.setEnterpriseApplicationsCSV(camelizeKeys(data.body.csv)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_ENTERPRISE_APPLICATIONS_CSV,
    });
  }

  return null;
}

export default getEntApplicationsCsv;
